<template>
  <div>
    <label for="input__mc-overview" class="h5 font-weight-bold mb-4">
      Type of Micro-Credential
    </label>
    <b-form-group id="input__radio-mc-level" class="mb-0" :disabled="disabled">
      <b-form-radio
        v-for="(level, key) in levels"
        :key="`input__radio-mc-level-${key}`"
        v-model="selectedLevel"
        name="mc-type"
        :value="key"
        class="mb-4"
      >
        <h5>{{ level.title }}</h5>
        <span class="mt-2">{{ level.description }}</span>
      </b-form-radio>
    </b-form-group>
  </div>
</template>

<script>
import { LEARNING_UNIT_LEVEL } from '@/constants';

export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    modelValue: {
      type: Object,
      default: () => ({
        level_type: null
      })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      LEARNING_UNIT_LEVEL,
      levels: {
        [LEARNING_UNIT_LEVEL.CAREER_SPECIFIC]: {
          title: 'Career Specific Micro-credential',
          description:
            'To assess real-world job competency or ability to perform as specified by the designer, both in tasks and within the context of the work environment.'
        },
        [LEARNING_UNIT_LEVEL.ACADEMIC_FOCUS]: {
          title: 'Academic Focused Micro-credential',
          description:
            'To assess hands-on practice or training or to measure the understanding of learners based on the work evidence.'
        }
      }
    };
  },

  computed: {
    selectedLevel: {
      get() {
        return this.modelValue.level_type;
      },

      set(level_type) {
        this.$emit('change', { level_type });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
